import type { DefaultValues } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import type { ISignUpFormValues } from '~/components/forms/SignUpForm';
import type { IAppRegion } from '~/lib/appSettings';
import { SignUpPage } from '~/components/pages/SignUpPage';
import { PageTemplate } from '~/components/templates/PageTemplate';

export const SignUpRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const nextUrl = searchParams.get('nextUrl') || undefined;
  const defaultValues: DefaultValues<ISignUpFormValues> = {
    firstName: searchParams.get('firstName') || undefined,
    lastName: searchParams.get('lastName') || undefined,
    phoneNumber: searchParams.get('phoneNumber') || undefined,
    email: searchParams.get('email') || undefined,
    affiliateCode: searchParams.get('affiliateCode') || undefined,
    appRegion: (searchParams.get('appRegion') || undefined) as
      | IAppRegion
      | undefined,
  };

  return (
    <PageTemplate>
      <SignUpPage nextUrl={nextUrl} defaultValues={defaultValues} />
    </PageTemplate>
  );
};
